import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SpinLoader = ({ size, black, positionStatic }) => {
  const containerClass = classNames('spin-loader spin-loader--loading', {
    'spin-loader--black': black,
    'spin-loader--static': positionStatic,
  });

  let iconSize;
  if (size) {
    iconSize = size;
  } else {
    iconSize = 'l';
  }

  return (
    <div className={containerClass}>
      <span className={`spin-loader__icon icon icon--${iconSize}`} />
    </div>
  );
};

SpinLoader.propTypes = {
  size: PropTypes.string,
  black: PropTypes.bool,
  positionStatic: PropTypes.bool,
};

export default SpinLoader;



// WEBPACK FOOTER //
// ./library/app/components/Global/Loaders/SpinLoader.js